// extracted by mini-css-extract-plugin
export default {"cost":"aiCost_cost__Uk+4+","inButton":"aiCost_inButton__njgaq","none":"aiCost_none__MrqQt"};